import { action, observable } from 'mobx';

export default class UserProfileStore {
  constructor(private appStore: any) {
    this.init();
  }

  @observable authToken: string = '';
  @observable userName: string = '';
  @observable userAvailable: boolean = false;
  @observable authError: boolean = false;
  @observable userPreferences: IUserPreferences[] = [];
  @observable lastSavedUserPreferencesJSON: string = JSON.stringify(this.userPreferences);
  @observable applicationFlags: IApplicationFlags = {};

  @action getPreference(category) {
    if (this.userPreferences.find) {
      const preferences = this.userPreferences.find(({ key }) => {
        return key === category;
      });
      if (preferences?.value) {
        return JSON.parse(preferences?.value);
      } else {
        return null;
      }
    }
  }
  @action setPreference(category, key, value) {
    if (this.userPreferences.find) {
      const preferences = this.userPreferences.find(({ key }) => {
        return key === category;
      });
      if (preferences?.value) {
        const json = JSON.parse(preferences?.value);
        json[key] = value;
        preferences.value = JSON.stringify(json);
      } else if (preferences) {
        // writing for the first time
        const obj = {};
        obj[key] = value;
        preferences.value = JSON.stringify(obj);
      }
    }
  }

  @action reset() {
    this.init();
  }

  @action init() {
    this.authToken = '';
    this.userName = '';
    this.userAvailable = false;
    this.authError = false;
    this.userPreferences = [];
    this.lastSavedUserPreferencesJSON = JSON.stringify(this.userPreferences);
    this.applicationFlags = {};
  }
}

export interface IUserPreferences {
  key: string;
  value?: string;
}
// this is Hydrology Preferences

export interface IHydrologyUserPreferences {
  dimUnitHydrogID?: number;
  state?: string;
  county?: string;
  client?: number;
  layer_visibilities?: {};
  storm_hydrograph?: boolean[];
  project_type?: number;
  poi_lat?: number;
  poi_long?: number;
}

// Previously in app-config
// Feature flags for which parts of the page load
// These are provided by Back-End service
export interface IApplicationFlags {
  enablesurface?: boolean;
  enablealignment?: boolean;
  enableterrace?: boolean;
  enableugo?: boolean;
  enablewaterway?: boolean;
  enablepit?: boolean;
  enablepond?: boolean;
  enablepipeline?: boolean;
  enablepad?: boolean;
  enablelandleveling?: boolean;
  enablesettings?: boolean;
  enablehydrocalc?: boolean;
  enabledesign?: boolean;
  enabledemsearch?: boolean;
  enableadminrole?: boolean;
  enableadmincontent?: boolean;
  enableadminlatestnews?: boolean;
  enableadminrelease?: boolean;
  enableadminroadmap?: boolean;
  enableadminglossary?: boolean;
  enableadminerrormgmt?: boolean;
  enableadminreports?: boolean;
  enableadminusermgmt?: boolean;
  enableadminglobalpreference?: boolean;
  enablewaterwaysizing?: boolean;
  enabledemfordesign?: boolean;
  enablesinglecrosssection?: boolean;
  enablecrosssectionviewer?: boolean;
  enableformulas?: boolean;// first half of formulas + list page overall
  enableformulas1?: boolean;// second half of formulas
  enableclippeddem?: boolean;
  enablevelocity?: boolean; //show velocity side of hydrology analysis
  enabledrlwaterway?: boolean;   // enable ai mode
  enabledemoncloud?: boolean;
  enableNAIPoncloud?: boolean;
}
